import { useFocus } from "screens/Root/hooks/RootAPI/useFocus";
import { useHotkeys } from "react-hotkeys-hook";
import { preventDefaultHandler } from "meta/utils/preventDefaultHandler";
const headerBind1 = "f2";
const headerBind2 = "ctrl+shift+h";
const mainTabBind1 = "f4";
const mainTabBind2 = "ctrl+shift+j";
const patientHeaderBind1 = "f7";
const patientHeaderBind2 = "ctrl+shift+k";
const chartTabsBind1 = "f8";
const chartTabsBind2 = "ctrl+shift+l";
const notificationsBind1 = "f9";
const notificationsBind2 = "ctrl+shift+g";
const showPageGuidBind = "f11";
export const useGlobalShortcutsRoot = () => {
    const { focusHeader, focusChartTabs, focusMainTab, focusNotificationCenter, focusPatientHeader, } = useFocus();
    useHotkeys(headerBind1, preventDefaultHandler(focusHeader));
    useHotkeys(headerBind2, preventDefaultHandler(focusHeader));
    useHotkeys(mainTabBind1, preventDefaultHandler(focusMainTab));
    useHotkeys(mainTabBind2, preventDefaultHandler(focusMainTab));
    useHotkeys(patientHeaderBind1, preventDefaultHandler(focusPatientHeader));
    useHotkeys(patientHeaderBind2, preventDefaultHandler(focusPatientHeader));
    useHotkeys(chartTabsBind1, preventDefaultHandler(focusChartTabs));
    useHotkeys(chartTabsBind2, preventDefaultHandler(focusChartTabs));
    useHotkeys(notificationsBind1, preventDefaultHandler(focusNotificationCenter), {}, [focusNotificationCenter]);
    useHotkeys(notificationsBind2, preventDefaultHandler(focusNotificationCenter), {}, [focusNotificationCenter]);
    useHotkeys(showPageGuidBind, preventDefaultHandler(window.RootAPI.Navigation?.showActivePageGuid), {}, [window.RootAPI.Navigation?.showActivePageGuid]);
};
export const initializeGlobalShortcutsContentTabs = () => {
    const { focusHeader, focusChartTabs, focusMainTab, focusNotificationCenter, focusPatientHeader, } = window.RootAPI.Focus;
    const { showActivePageGuid } = window.RootAPI.Navigation;
    window.Hotkeys.bind({
        [headerBind1]: preventDefaultHandler(focusHeader),
        [headerBind2]: preventDefaultHandler(focusHeader),
        [mainTabBind1]: preventDefaultHandler(focusMainTab),
        [mainTabBind2]: preventDefaultHandler(focusMainTab),
        [patientHeaderBind1]: preventDefaultHandler(focusPatientHeader),
        [patientHeaderBind2]: preventDefaultHandler(focusPatientHeader),
        [chartTabsBind1]: preventDefaultHandler(focusChartTabs),
        [chartTabsBind2]: preventDefaultHandler(focusChartTabs),
        [notificationsBind1]: preventDefaultHandler(focusNotificationCenter),
        [notificationsBind2]: preventDefaultHandler(focusNotificationCenter),
        [showPageGuidBind]: preventDefaultHandler(showActivePageGuid),
    }, true, true);
};
